import React from 'react';
import ACTION from './action';
import Input from '../../../components/Input';
import WithLabelAction from '../../../components/WithLabelAction';

import { EmailReg } from '../../../common/RegExp';
import { useDispatch, useSelector } from 'react-redux';
import { checkFillDataValid, checkContactEmailRequired } from '../../../apis/MethodList';


if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

export interface IContactEmailInput {
    placeholder?: string;
    label?: string;
    required?: boolean;
    id?: string;
}

export const VerifyContactEmailAction = async (value: string, repairAccount?: string) => {
    try {
        if (!EmailReg.test(value)) {
            return { isValid: false, desc: '请输入正确的邮箱号' };
        }
        if (repairAccount && repairAccount === value) {
            return { isValid: false, desc: '修复邮箱不可作为联系邮箱使用' };
        }
        const res = await checkFillDataValid({
            item: "EMAIL",
            data: value,
        });
        return {
            isValid: res?.code === 200,
            desc: res?.desc || "联系邮箱不合法",
        }
    } catch (e) {
        console.log(e);
        return {
            isValid: false,
            desc: "服务校验异常",
        }
    }
};

const ContactEmailInput: React.FC<IContactEmailInput> = ({ placeholder, label, required, id }) => {

    const dispatch = useDispatch();
    const global = useSelector((state: any) => state.global);
    const { contactEmail, errorText, isNeedContactEmail } = useSelector((state: any) => state.ContactEmailInput);

    const onBurCheckValue = async (value: string) => {
        try {
            if (!EmailReg.test(value)) {
                dispatch({
                    type: ACTION.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                    payload: '请输入正确的邮箱账号'
                });
                return;
            }
            if (global.repairAccount === value) {
                dispatch({
                    type: ACTION.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                    payload: '修复邮箱不可作为联系邮箱使用'
                });
                return;
            }
            const { isValid, desc, } = await VerifyContactEmailAction(value, global.repairAccount);
            !isValid && dispatch({
                type: ACTION.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                payload: desc,
            });
        } catch (e) {
            console.log(e);
        }
    }

    const handleNameChange = (value: string) => {
        const email = value.replace(/\s/g, '');
        dispatch({
            type: ACTION.UPDATE_CONTACT_EMAIL,
            payload: email,
        })
        if (email) {
            dispatch({
                type: ACTION.UPDATE_CONTACT_EMAIL_ERROR_TEXT,
                payload: ''
            })
        }
    }

    const checkEmailRequiredHandle = async () => {
        try {
            const res = await checkContactEmailRequired();
            if (res?.code === 200) {
                dispatch({
                    type: ACTION.UPDATE_CONTACT_EMAIL_NEED,
                    payload: res?.result?.email,
                })
            }
        } catch (e) {
            console.log(e);
        }
    }

    React.useLayoutEffect(() => {
        checkEmailRequiredHandle();
    }, []);

    return isNeedContactEmail ? (
        <>
            <WithLabelAction
                id={id}
                label={label || "联系邮箱（用于接收审核结果）"}
                required={required}
                htmlFor="name-input"
                actionPos="top"
                ActionBtn={null}
            >
                <Input
                    inputId={"contact-email-input"}
                    maxLength={30}
                    errorText={errorText}
                    onBur={value => onBurCheckValue(value)}
                    onChange={value => handleNameChange(value)}
                    defaultValue={contactEmail}
                    placeholder={placeholder}
                />
            </WithLabelAction>
        </>
    ): null;

};

export default ContactEmailInput;